// Generated by purs version 0.13.5
"use strict";
var $foreign = require("./foreign.js");
var React_Basic = require("../React.Basic/index.js");
var React_Basic_DOM = require("../React.Basic.DOM/index.js");
var React_Basic_DOM_Generated = require("../React.Basic.DOM.Generated/index.js");
var WebApp_Gallery = require("../WebApp.Gallery/index.js");
var WebApp_Sidenav = require("../WebApp.Sidenav/index.js");
var component = React_Basic.createComponent("App");
var app = React_Basic.makeStateless(component)(function (props) {
    return React_Basic.fragment([ React_Basic_DOM_Generated.nav_([ React_Basic_DOM_Generated.div()({
        className: "nav-wrapper brown darken-1",
        children: [ React_Basic_DOM_Generated.a()({
            href: "https://github.com/section77/werbematerial",
            className: "brand-logo right hide-on-med-and-down",
            children: [ React_Basic_DOM.text("S77 Werbematerial") ]
        }), React_Basic_DOM_Generated.ul_([ React_Basic_DOM_Generated.li_([ WebApp_Sidenav.sidenav({
            items: props.items,
            onClick: $foreign.scrollElementByIdIntoView
        }) ]) ]) ]
    }) ]), React_Basic_DOM_Generated.div()({
        className: "row",
        children: [ WebApp_Gallery.gallery(props) ]
    }) ]);
});
module.exports = {
    component: component,
    app: app,
    scrollElementByIdIntoView: $foreign.scrollElementByIdIntoView
};
